"use strict";
var $dyn;
(function ($dyn) {
    var ui;
    (function (ui) {
        function isPopupHost(obj) {
            return obj.Popup ? true : false;
        }
        ui.isPopupHost = isPopupHost;
        /**
         * Apply the popup properties (Popup, PopupId, popupHostElement) and functions (showPopup) to the this context.
         * @param role The role of the popup when it is being created
         */
        function popupHost(popupFormOptions) {
            var _this = this;
            this.Popup = $dyn.observable();
            this.PopupId = $dyn.observable();
            if (this.ShowFlyout !== undefined) {
                if (!$dyn.isObservable(this.ShowFlyout)) {
                    this.ShowFlyout = $dyn.observable(this.ShowFlyout);
                }
            }
            else {
                this.ShowFlyout = $dyn.observable(false);
            }
            this.popupHostElement = undefined;
            this.showPopup = function (popupObservable, popupOptions) {
                var popup = _this.Popup();
                if (!popup) {
                    var id_1 = _this.PopupId();
                    if (!id_1) {
                        var options_1 = popupFormOptions ? $dyn.util.objectAssign({}, popupFormOptions) : { role: "Popup" };
                        _this.popupHostElement = $dyn.shell.createForm(options_1);
                        $dyn.log.popups && $dyn.log.popups("Popups: Popup ID set from %s to %s", $dyn.peek(_this.PopupId), _this.popupHostElement.getAttribute("data-dyn-formid"));
                        id_1 = _this.PopupId(_this.popupHostElement.getAttribute("data-dyn-formid"));
                        // Note: Wire up this state early so that we can cancel pending lookups during shortcut key handlers, etc.
                        var requestedPopupForm_1 = $dyn.context(_this.popupHostElement);
                        if (requestedPopupForm_1) {
                            requestedPopupForm_1.highlyResponsive = _this.highlyResponsivePopups;
                            if (popupOptions) {
                                requestedPopupForm_1.routeMessagesToParent = popupOptions.routeMessagesToParent;
                            }
                            if (_this && _this.pendingPopup) {
                                var pendingPopup = {
                                    cancel: function () {
                                        if ($dyn.log.popups) {
                                            $dyn.log.popups("Popups: Lookup canceled for %s (flyout id %s)", (_this._element && _this._element.id), requestedPopupForm_1 && requestedPopupForm_1.Name ? requestedPopupForm_1.Name : "<unknown>");
                                        }
                                        // If the popupForm has not already been closed (such as in the case where no popup is returned), abort the popup.
                                        if (requestedPopupForm_1 && ($dyn.value(requestedPopupForm_1.ReadyState) !== $dyn.ui.ReadyState.closed)) {
                                            requestedPopupForm_1.ReadyState($dyn.ui.ReadyState.aborted);
                                        }
                                        _this.ShowFlyout(false);
                                        _this.pendingPopup(undefined);
                                    }
                                };
                                _this.pendingPopup(pendingPopup);
                            }
                        }
                        popup = _this.Popup($(_this.popupHostElement));
                        $dyn.async(function () {
                            if (_this.popupHostElement) {
                                // The interaction callback will not be called immediately in server-side form "wait" scenarios. Instead leverage the loaded event
                                // on popups which is guaranteed to be called if the interaction is successful.
                                $dyn.context(_this.popupHostElement).onPopupReceived = function (onPopupReceivedEvent) {
                                    if (_this.pendingPopup) {
                                        _this.pendingPopup(undefined);
                                    }
                                    var popupContext = null;
                                    if (popup) {
                                        popupContext = $dyn.context(popup[0]);
                                    }
                                    // allow the interactions to finish processing then check the popup
                                    $dyn.async(function () {
                                        // if we have the popup is it still in a ready state of request?
                                        if (popup && popupContext && $dyn.value(popupContext.ReadyState) !== $dyn.ui.ReadyState.aborted) {
                                            if (!popupContext.isActivePopup()) {
                                                // the call returned but the popup is no longer the active form (another form was opened)
                                                if ($dyn.log.popups) {
                                                    $dyn.log.popups("Popups: Closing lookup for control %s / %s (flyout id %s) -- no longer the active form", _this.Name ? _this.Name : "<unknown>", (_this._element && _this._element.id) ? _this._element.id : "<unknown>", requestedPopupForm_1 && requestedPopupForm_1.Name ? requestedPopupForm_1.Name : "<unknown>");
                                                }
                                                onPopupReceivedEvent.cancel();
                                            }
                                        }
                                    }, 0, "Wait for interactions to check popup");
                                };
                            }
                            var checkCommandCallback = function (requestPopupReturn) {
                                var popupContext = null;
                                if (popup) {
                                    popupContext = $dyn.context(popup[0]);
                                }
                                if (popupContext) {
                                    // tslint:disable-next-line:triple-equals
                                    if ($dyn.value(popupContext.ReadyState) === $dyn.ui.ReadyState.request || requestPopupReturn !== undefined && requestPopupReturn != 0) {
                                        // the request was canceled or there was an error
                                        if ($dyn.log.popups) {
                                            $dyn.log.popups("Popups: Closing lookup for control %s / %s (flyout id %s) -- there was an error", _this.Name ? _this.Name : "<unknown>", (_this._element && _this._element.id) ? _this._element.id : "<unknown>", requestedPopupForm_1 && requestedPopupForm_1.Name ? requestedPopupForm_1.Name : "<unknown>");
                                        }
                                        if (($dyn.value(popupContext.ReadyState) !== $dyn.ui.ReadyState.closed)) {
                                            // Should not call request close without formally receiving a form
                                            $dyn.shell.close({ form: popupContext });
                                        }
                                    }
                                    else if (!popupContext.popupAborted && popupContext.Children && popupContext.Children().length === 0) {
                                        // the popup has not already been aborted and it still in a ready state of request and the call returned but did not open a popup
                                        if ($dyn.log.popups) {
                                            $dyn.log.popups("Popups: Closing lookup for control %s / %s (flyout id %s) -- empty lookup form", _this.Name ? _this.Name : "<unknown>", (_this._element && _this._element.id) ? _this._element.id : "<unknown>", requestedPopupForm_1 && requestedPopupForm_1.Name ? requestedPopupForm_1.Name : "<unknown>");
                                        }
                                        if (_this.pendingPopup) {
                                            _this.pendingPopup(undefined);
                                        }
                                        $dyn.getFunction(popupContext.Close)();
                                    }
                                    else {
                                        if (_this.setupAccessibilityForLookup) {
                                            _this.setupAccessibilityForLookup();
                                        }
                                    }
                                }
                            };
                            var checkFailureCallback = function () {
                                var popupContext = null;
                                if (popup) {
                                    popupContext = $dyn.context(popup[0]);
                                }
                                if (popupContext) {
                                    $dyn.getFunction(popupContext.Close)();
                                }
                            };
                            // If the new control requires up to date information about last focused control outside action pane
                            if (_this.Root && _this.Root.updateLastClientSelectedControl && $dyn.value(_this.RequiresSelectedControl) === true && $dyn.value(_this.Root.IsForm) === true) {
                                _this.Root.updateLastClientSelectedControl();
                            }
                            var displayedValues = "";
                            if (_this.displayedValues) {
                                displayedValues = _this.displayedValues(true);
                            }
                            if (_this.$inputElement && _this.$inputElement[0]) {
                                // If the control requesting the popup has an input element, also send
                                // the cursor position when the lookup was opened as an argument.
                                displayedValues = displayedValues || {};
                                displayedValues.__selectionStart = String($dyn.ui.selectionStart(_this.$inputElement[0]));
                                displayedValues.__selectionEnd = String($dyn.ui.selectionEnd(_this.$inputElement[0]));
                            }
                            if ($dyn.log.popups) {
                                $dyn.log.popups("Popups: Requesting lookup for control %s/%s (flyout id %s)", (_this && _this.Name) ? _this.Name : "<unknown>", (_this._element && _this._element.id) ? _this._element.id : "<unknown>", (requestedPopupForm_1 && requestedPopupForm_1.Name) ? requestedPopupForm_1.Name : "<unknown>");
                            }
                            // Ideally should not be using positioned argument and async (as the async is a workarround for the RequestPopup logic)  and should have a callback.
                            $dyn.callFunction(_this.RequestPopup, _this, [id_1, displayedValues], checkCommandCallback, undefined, undefined, undefined, checkFailureCallback);
                        }, 0, "$dyn.ui.popupHost RequestPopup");
                    }
                    else {
                        if ($dyn.log.popups) {
                            $dyn.log.popups("Popups: Recycling lookup for control %s / (flyout id %s) -- popup ID already set", _this.Name ? _this.Name : "<unknown>", (_this._element && _this._element.id) ? _this._element.id : "<unknown>");
                        }
                        popup = _this.Popup($("#form_" + id_1));
                    }
                }
                else if ($dyn.context(popup[0]).ReadyState() === $dyn.ui.ReadyState.aborted || popup[0].isClosing) {
                    // Requested a lookup while waiting for the lookup to close. Have dynClose open the lookup when it is finished.
                    popup[0].wasPopupOpenedDeferredForExistingClose = true;
                    if (_this && _this.pendingPopup) {
                        var pendingPopup = {
                            cancel: function () {
                                var requestedPopupForm = $dyn.context(_this.popupHostElement);
                                if ($dyn.log.popups) {
                                    $dyn.log.popups("Popups: Deferred lookup canceled for %s (flyout id %s)", (_this._element && _this._element.id) ? _this._element.id : "<unknown>", requestedPopupForm && requestedPopupForm.Name ? requestedPopupForm.Name : "<unknown>");
                                }
                                popup[0].wasPopupOpenedDeferredForExistingClose = false;
                                _this.ShowFlyout(false);
                                _this.pendingPopup(undefined);
                            }
                        };
                        _this.pendingPopup(pendingPopup);
                    }
                    if ($dyn.log.popups) {
                        $dyn.log.popups("Popups: Deferred lookup queued for %s; current ShowFlyout value is %s", (_this._element && _this._element.id) ? _this._element.id : "<unknown>", $dyn.peek(_this.ShowFlyout));
                    }
                    if (!$dyn.peek(_this.ShowFlyout)) {
                        _this.ShowFlyout(true);
                    }
                    else {
                        // In this branch because ShowFlyout got set to true; trigger the observable so that the loading animation, etc., is re-applied.
                        popupObservable.valueChanged.raise();
                    }
                }
                else {
                    _this.popupHostElement = popup[0];
                    if ($dyn.log.popups) {
                        var popupContext = $dyn.context(popup[0]);
                        $dyn.log.popups("Popups: Skipping generating lookup for control %s / %s (flyout id %s) -- popup already created", _this.Name ? _this.Name : "<unknown>", (_this._element && _this._element.id) ? _this._element.id : "<unknown>", popupContext.Name ? popupContext.Name : "<unknown>");
                    }
                }
                // This is called by form _close, do not call directly.
                popup[0].dynClose = function () {
                    _this.Popup(null);
                    $dyn.log.popups && $dyn.log.popups("Popups: Popup ID set from %s to null", $dyn.peek(_this.PopupId));
                    _this.PopupId(null);
                    popupObservable(null);
                    $dyn.flyout.flyoutManager.removeFlyoutByElementId(popup[0].getAttribute("id"));
                    // Removing the flyout form
                    $(_this.popupHostElement).remove();
                    var context = $dyn.context(popup[0]);
                    if ($dyn.shell.getActiveForm() === popup[0]) {
                        // re-activate the correct form
                        $dyn.shell.tryActivateParentElement(_this, { takeNavigationFocus: context.shouldResetFocusOnClose ? context.shouldResetFocusOnClose() : true });
                    }
                    if (context && !context.closeCallback && _this.ShowFlyout() && !popup[0].wasPopupOpenedDeferredForExistingClose) {
                        _this.ShowFlyout(false);
                    }
                    if (popup[0].wasPopupOpenedDeferredForExistingClose) {
                        // A lookup was requested while waiting for an aborted lookup to close. Open the deferred lookup.
                        // Note that this is done asynchronously to let the current flyout close process complete.
                        $dyn.async(function () {
                            if ($dyn.log.popups) {
                                var requestedPopupForm = $dyn.context(_this.popupHostElement);
                                $dyn.log.popups("Popups: Deferred lookup being performed for %s (flyout id %s) -- lookup was requested while still handling aborted lookup", (_this._element && _this._element.id) ? _this._element.id : "<unknown>", requestedPopupForm && requestedPopupForm.Name ? requestedPopupForm.Name : "<unknown>");
                            }
                            if (!$dyn.peek(_this.ShowFlyout)) {
                                _this.ShowFlyout(true);
                            }
                            else {
                                _this.ShowFlyout.valueChanged.raise();
                            }
                        }, 0, "Waiting for aborted popup to close before opening popup lookup");
                        popup[0].wasPopupOpenedDeferredForExistingClose = false;
                    }
                    _this.popupHostElement = undefined;
                    // It's possible for close to be hit multiple times in error conditions.
                    popup[0].dynClose = $dyn.util.emptyfunction;
                    popup[0].isClosed = true;
                    popup[0].RequestPopupClose = $dyn.util.emptyfunction;
                };
                popup[0].RequestPopupClose = function (closeCallback, record) {
                    var context = $dyn.context(popup[0]);
                    if (context && context.Close) {
                        if (context.element && $dyn.value(context.element.dynReadyState) === $dyn.ui.ReadyState.ready) {
                            if (_this.highlyResponsivePopups) {
                                // Immediately reset our flyout state so that the user can request another popup while the outstanding close is still being processed.
                                _this.ShowFlyout(false);
                                popup[0].isClosing = true;
                            }
                            $dyn.getFunction(context.Close)({
                                closeCallback: function () {
                                    // make sure the flag is reset
                                    $dyn.getFunction(closeCallback)();
                                    if (!_this.highlyResponsivePopups) {
                                        _this.ShowFlyout(false);
                                    }
                                },
                                record: record
                            });
                        }
                        else {
                            // If the flyout was never opened, don't send a request to the server to close it.
                            // Unregister the flyout from the stack.
                            // The flyout might not have opened if there was an error thrown in init of the form.
                            $dyn.flyout.flyoutManager.removeFlyoutByElementId(context.element.getAttribute("id"));
                            if (typeof (closeCallback) === "function") {
                                closeCallback();
                            }
                            _this.ShowFlyout(false);
                        }
                    }
                };
                popupObservable(popup);
                return popup;
            };
        }
        ui.popupHost = popupHost;
    })(ui = $dyn.ui || ($dyn.ui = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=popupHost.js.map
